import React from 'react';
import { CheckIcon, InfoIcon } from 'lucide-react';
import { volumes, extras } from '../data/content';
import { ListChecksIcon, ClipboardCheckIcon, CalendarDaysIcon, BarChart3Icon, ImageIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
const extraIcons = {
  list: ListChecksIcon,
  check: ClipboardCheckIcon,
  calendar: CalendarDaysIcon,
  chart: BarChart3Icon,
  image: ImageIcon
};
export function Volumes() {
  return <section className="bg-cream px-4 py-14" data-id="element-275" data-mp="24unwr9yag3r0">
      <div className="mx-auto max-w-4xl" data-id="element-276" data-mp="24tcuxfoel62j">
        <SectionHeading title={<>What’s inside <em className="text-plum" data-id="element-278" data-mp="1qu3goljrcm17">The Peaceful Night Method™?</em></>} subtitle="6 premium volumes that take you from your first night to a routine you keep." data-id="element-277" data-mp="1quwf8z8kc589" />

        <ol className="mt-10 space-y-5" data-id="element-279" data-mp="feesxryojizc">
          {volumes.map(v => <li key={v.number} className="overflow-hidden rounded-3xl bg-white shadow-[0_8px_30px_-12px_rgba(29,35,82,0.25)]" data-id="element-280" data-mp="keu7unym0yjf">
              <div className="flex items-center gap-4 bg-plum px-5 py-4" data-id="element-281" data-mp="3o8y8mwc4udm7">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gold font-serif text-lg font-bold text-night" data-id="element-282" data-mp="3j9vdq4pv9nry">{v.number}</span>
                <div data-id="element-283" data-mp="1ylxis83n2xe">
                  <p className="text-xs font-bold uppercase tracking-widest text-lavender-deep" data-id="element-284" data-mp="3t6qaoj6hrg44">Volume {v.number}</p>
                  <h3 className="font-serif text-xl font-bold leading-tight text-white sm:text-2xl" data-id="element-285" data-mp="b0v81i3dawas">{v.title}</h3>
                </div>
              </div>
              <div className="p-5 sm:p-7" data-id="element-286" data-mp="60pjwbwb3rxg">
                <p className="text-base leading-relaxed text-muted" data-id="element-287" data-mp="krpv2ooftzxa">{v.description}</p>

                {v.nights && <ol className="mt-5 space-y-2" data-id="element-288" data-mp="fsvbhkinc7c4">
                    {v.nights.map((n, i) => <li key={n} className="flex items-center gap-3 rounded-xl bg-lavender px-3 py-2.5" data-id="element-289" data-mp="tsnyb4r1y3et" data-mpi={i}>
                        <span className="w-16 shrink-0 text-xs font-extrabold uppercase text-plum" data-id="element-290" data-mp="ps3ytuj0anpi">Night {i + 1}</span>
                        <span className="text-[15px] font-medium text-ink" data-id="element-291" data-mp="wrmsryjkv7q0">{n}</span>
                      </li>)}
                  </ol>}

                <p className="mt-5 text-sm font-bold uppercase tracking-wide text-plum" data-id="element-292" data-mp="16qca9q7kaq5q">{v.listLabel}:</p>
                <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-293" data-mp="1bk6ssqbfkz38">
                  {v.items.map(item => <li key={item} className="flex gap-2 text-[15px] leading-snug text-ink" data-id="element-294" data-mp="1fmbhdan0v5j0">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-295" data-mp="1khh3a9gfck73" />
                      <span data-id="element-296" data-mp="1pj6cdjk36nsj">{item}</span>
                    </li>)}
                </ul>

                {v.note && <p className="mt-5 rounded-xl bg-gold-light px-4 py-3 text-sm font-medium text-ink" data-id="element-297" data-mp="1uf57rr3u162g">{v.note}</p>}
                {v.disclaimer && <p className="mt-5 flex gap-2 rounded-xl bg-lavender px-4 py-3 text-xs leading-relaxed text-muted" data-id="element-298" data-mp="4i0rkjbl9vk">
                    <InfoIcon className="h-4 w-4 shrink-0 text-plum" aria-hidden="true" data-id="element-299" data-mp="2dfb2eao98jao" />
                    <span data-id="element-300" data-mp="28m8ae6z4lhwl"><strong data-id="element-301" data-mp="28lgojnvbyyji">Note:</strong> {v.disclaimer}</span>
                  </p>}
              </div>
            </li>)}
        </ol>

        <CtaButton className="mt-10" label="I want access to the complete system" data-id="element-302" data-mp="1zmv7xy9f5tld" />

        <div className="mt-16" data-id="element-303" data-mp="2wccbo7oud5kf">
          <SectionHeading title="You’ll also receive immediate access to:" data-id="element-304" data-mp="2wbks5v8iqyai" />
          <ul className="mt-8 divide-y divide-lavender-deep rounded-3xl bg-white px-5 shadow-sm" data-id="element-305" data-mp="2sahcp9udv49t">
            {extras.map(e => {
            const Icon = extraIcons[e.icon];
            return <li key={e.title} className="flex items-start gap-4 py-5" data-id="element-306" data-mp="2idme6qy413vj">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-lavender" data-id="element-307" data-mp="1bwr69wfsk3x0">
                    <Icon className="h-5 w-5 text-plum" aria-hidden="true" data-id="element-308" data-mp="16x4t1mzyqno7" />
                  </span>
                  <div data-id="element-309" data-mp="2utu8133rkez9">
                    <h3 className="text-base font-bold text-ink" data-id="element-310" data-mp="2utaxi7gg0sv9">{e.title}</h3>
                    <p className="mt-1 text-[15px] leading-relaxed text-muted" data-id="element-311" data-mp="2zllw96zg68m8">{e.text}</p>
                  </div>
                </li>;
          })}
          </ul>
          <p className="mx-auto mt-6 max-w-xl text-center text-[17px] text-ink" data-id="element-312" data-mp="2qss78hu77uv6">
            No matter what kind of day you’ve had, you’ll have a simple system to help you know how to begin winding down.
          </p>
          <CtaButton className="mt-8" label="I want the complete system" data-id="element-313" data-mp="3ikgeipy4dr75" />
        </div>
      </div>
    </section>;
}